import { Auth } from '@aws-amplify/auth';
let mock = undefined;
export const mockAccessToken = ({ token }) => {
    mock = token;
    return () => {
        mock = undefined;
    };
};
export const getAccessToken = ({ withBearer } = {}) => {
    if (mock)
        return Promise.resolve(mock);
    return Auth.currentSession()
        .then((session) => session.getIdToken().getJwtToken())
        .then((token) => `${withBearer ? 'Bearer ' : ''}${token}`);
};
//# sourceMappingURL=getAccessToken.js.map